import { AlertSchema } from "../../types";
import { sigv4ApiClient } from "./internal/sigv4ApiClient";
import { createEntityId } from "./internal/entityId";

const API_PATH = "/v1/alarm-schema";

export const alertSchemaService = {
  create: async (input: Omit<AlertSchema, "id" | "system">): Promise<AlertSchema> => {
    const created: AlertSchema = { ...input, system: false, id: createEntityId() };
    return sigv4ApiClient.put<AlertSchema>(API_PATH, created);
  },

  list: async (): Promise<AlertSchema[]> => {
    return sigv4ApiClient.list<AlertSchema>(API_PATH);
  },

  get: async (id: string): Promise<AlertSchema | undefined> => {
    return sigv4ApiClient.get<AlertSchema>(`${API_PATH}/${encodeURIComponent(id)}`);
  },

  update: async (
    id: string,
    next: Omit<AlertSchema, "id">
  ): Promise<AlertSchema> => {
    const current = await alertSchemaService.get(id);
    if (!current) {
      throw new Error(`AlertSchema with id "${id}" not found`);
    }
    if (current.system) {
      throw new Error("System alert schemas cannot be edited.");
    }
    return sigv4ApiClient.put<AlertSchema>(API_PATH, { ...next, id });
  },

  patch: async (
    id: string,
    patch: Partial<Omit<AlertSchema, "id">>
  ): Promise<AlertSchema> => {
    const current = await alertSchemaService.get(id);
    if (!current) {
      throw new Error(`AlertSchema with id "${id}" not found`);
    }
    if (current.system) {
      throw new Error("System alert schemas cannot be edited.");
    }

    return sigv4ApiClient.put<AlertSchema>(API_PATH, { ...current, ...patch, id });
  },

  delete: async (id: string): Promise<boolean> => {
    const current = await alertSchemaService.get(id);
    if (!current) {
      return false;
    }
    if (current.system) {
      return false;
    }
    await sigv4ApiClient.delete(`${API_PATH}/${encodeURIComponent(id)}`);
    return true;
  }
};
